"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var TransactionType_Factory = /** @class */ (function () {
    function TransactionType_Factory() {
    }
    TransactionType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Category: model.Category,
            CategoryId: model.CategoryId,
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    TransactionType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Category: model.Category,
            CategoryId: model.CategoryId,
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return TransactionType_Factory;
}());
exports.TransactionType_Factory = TransactionType_Factory;
